import React from 'react'
import './style.scss'
import { Section } from '../ui'

export default function ReactjsHome(props) {
  return (
    <div className="sw-pad">
      <Section label={"React JS"}>
      </Section>
    </div>
  )
}
